// removed by extract-text-webpack-plugin
module.exports = {"CounterContainer":"CounterContainer---2MS_t","Counter":"Counter---1486f"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/shared/QuotaBar/style.styl
// module id = 4ODQ
// module chunks = 89